import React from "react";
import { EditLoadioStoreFeaturedSectionContentTemplate } from "themes/administration/loadio/components";
import { EditLoadioStoreFeaturedSectionContentViewStore } from "administration/loadio/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new EditLoadioStoreFeaturedSectionContentViewStore(rootStore, componentProps),
    "editLoadioStoreFeaturedSectionContentViewStore"
)
class EditLoadioStoreFeaturedSectionContent extends React.Component {
    render() {
        return <EditLoadioStoreFeaturedSectionContentTemplate {...this.props} />;
    }
}

export default EditLoadioStoreFeaturedSectionContent;
